import { DefaultTheme } from "./DefaultTheme";
export class LightTheme {
}
LightTheme.theme = {
    saasAiAppTheme: {
        ...DefaultTheme.theme.saasAiAppTheme,
    },
    nodeTheme: {
        ...DefaultTheme.theme.nodeTheme,
    },
    appSignUpButtonTheme: {
        ...DefaultTheme.theme.appSignUpButtonTheme,
    },
    patchTheme: {
        renderingTransitionColors: "#ecf2fc",
        nodeWrapperShadow: "0px 30px 60px 0px rgba(0, 0, 0, 0.15)",
        nodeBackdropFilter: "blur(20px)",
    },
};
